import { render, staticRenderFns } from "./ProductChassisEngine.vue?vue&type=template&id=0bddc4c5&scoped=true"
import script from "./ProductChassisEngine.vue?vue&type=script&lang=js"
export * from "./ProductChassisEngine.vue?vue&type=script&lang=js"
import style0 from "./ProductChassisEngine.vue?vue&type=style&index=0&id=0bddc4c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bddc4c5",
  null
  
)

export default component.exports